<template>
    <div class="main_body">
        <div class="input_search mb-4">
            <input v-model="model_find" @keypress.enter="findname" type="text" placeholder="Search" class="form-control">
            <svg @click="findname" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
            </svg>
        </div>
        <div class="d-flex justify-content-between">
            <div>
                <button @click="addVideo" class="btn btn-primary">+ ADD NEW CAMERA</button>
                <button @click="deleteCameras()" class="btn" :class="[ btn_delete_checked ? 'btn-border' : 'btn-border-light']">DELETE</button>
            </div>
            <div>
                <button @click="stopCameras()" class="btn" :class="[ btn_stop_checked ? 'btn-border' : 'btn-border-light']">STOP</button>
                <button @click="analizeCameras()" class="btn" :class="[ btn_analyze_checked ? 'btn-border' : 'btn-border-light']">ANALYZE</button>
            </div>
        </div>
        <table class="table mt-5 fz09">
            <tr class="titlesRow">
                <th>
                    <div class="d-flex align-items-center">
                        <div class="">
                            <input v-model="model_all" @change="checkAll" id="top" type="checkbox" class="custom_checkbox">
                            <label for="top"></label>
                        </div>
                        <span @click="sortName" class="cursor_pointer">
                        <iconsort :updown="sort_name"></iconsort>
                        <span>Name</span>
                    </span>
                    </div>
                </th>
                <th>
                    <span @click="sortPerson" class="cursor_pointer">
                        <iconsort :updown="sort_person"></iconsort>
                        <span>Description</span>
                    </span>
                </th>
                <th>
                    <span @click="sortPerson" class="cursor_pointer">
                        <iconsort :updown="sort_person"></iconsort>
                        <span>Status</span>
                    </span>
                </th>
                <th>Preview</th>
                <th>
                    <span @click="sortPerson" class="cursor_pointer">
                        <iconsort :updown="sort_person"></iconsort>
                        <span>Last activity</span>
                    </span>
                </th>
                <th></th>
                <th></th>
            </tr>
            <tr v-for="(camera, key) in camerasItem" :key="camera.id" class="black_line">
                <td class="nameCol">
                    <div class="avatar_and_title d-flex justify-content-start">
                        <div class="">
                            <input 
                                v-model="camera.checked" 
                                @change="changeItem(camera.id)" 
                                :id="`t_${key}`" 
                                type="checkbox" 
                                class="custom_checkbox"
                            >
                            <label :for="`t_${key}`">{{camera.name}}</label>
                        </div>
                    </div>
                </td>
                <td class="descCol">
                    {{camera.description}}
                </td>
                <td class="statusCol">
                    <statuscamera
                        :v_id="camera.id"
                        :status="camera.status_id"
                        :status_name="camera.status ? camera.status.status : 'NOT ANALYZED'"
                        :statuses="statuses"
                    ></statuscamera>                    
                </td>
                <td class="previewCol" @click.stop="openCameraStream(camera)" title="Open live stream">
                    <div class="camera-preview-wrap">
                        <img
                            v-show="previewReady[camera.id]"
                            width="130"
                            class="camera-preview-thumb"
                            :src="previewUrl[camera.id]"
                            alt="preview"
                            @error="onPreviewError(camera.id)"
                        >
                        <div
                            v-show="!previewReady[camera.id]"
                            class="camera-preview-placeholder"
                            aria-label="Loading preview"
                        >
                            <span class="camera-preview-spinner"></span>
                        </div>
                    </div>
                </td>
                <td class="lastactCol">
                    {{camera.last_activity}}
                </td>
                <td class="alnalyzeCol">
                    <span class="statusvideo_buttons">
                        <button 
                            v-show="!camera.status_id" 
                            @click="analizeCamera(camera.id)"  
                            class="btn btn-border btn-sm table-list-row__action" 
                            :data-id='camera.id' 
                        >
                            ANALYZE
                        </button>
                        <button 
                            v-show="((camera.status_id == 1) || 
                                    (camera.status_id == 2))" 
                            @click="stopAnalizeCamera(camera.id)"  
                            class="btn btn-border-light btn-sm table-list-row__action"
                        >
                            STOP
                        </button>
                        <button 
                            v-show="((camera.status_id == 3) || 
                                    (camera.status_id == 4) || 
                                    (camera.status_id == 5))" 
                            @click="beginAnalizeCamera(camera.id)"  
                            class="btn btn-border btn-sm table-list-row__action" :data-id='camera.id' 
                        >
                            BEGIN ANALYZE
                        </button>
                    </span>
                </td>
                <td class="subMenuCol">
                    <div class="dotscontrol">
                        <div class="dotscontrol_dots" 
                            type="button" 
                            :id="`dropdownMenuButton${key}`" 
                            data-bs-toggle="dropdown" aria-expanded="false"
                        >                        
                            <!-- <div @click.prevent="openSettings(camera.id)"  class="dotscontrol_dots"> -->
                            <span class="dotscontrol_dots__span"></span>
                        </div>
                        
                        <ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton${key}`">
                            <li><a @click="editCamera(camera)" class="dropdown-item" href="#">EDIT</a></li>
                            <li> <a @click="deleteCamera(camera.id)" class="dropdown-item" >DELETE</a></li>
                        </ul>
                    </div>
                </td>
            </tr>
        </table>

        <div class="bottom_panel d-flex align-items-center justify-content-end mt-5">
            <div class="bottom_panel_right">
                <div class="label_and_input_line d-flex">
                    <label for="select_count_item_cam">Show:</label>
                    <select
                        v-model="model_counitempage"
                        @change="onPerPageChange"
                        id="select_count_item_cam"
                        class="form-select"
                        aria-label="Cameras per page"
                    >
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select>
                </div>
                <pagin align="center" :data="data" @pagination-change-page="changePage">
                    <span slot="prev-nav">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.91456 0.958033L2.00028 7.04255L8.0848 12.9568" stroke="white" stroke-width="2"/>
                        </svg>
                    </span>
                    <span slot="next-nav">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.999999 13L7 7L0.999999 1" stroke="white" stroke-width="2"/>
                        </svg>
                    </span>
                </pagin>
                <div class="label_and_input_line d-flex">
                    <label for="to_page_cam">Move to page:</label>
                    <input
                        @keypress.enter="event => changePage(event.target.value)"
                        type="number"
                        class="form-control"
                        id="to_page_cam"
                        min="1"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../bus';
import axios from 'axios';
import Pagin from 'laravel-vue-pagination';
import Dotscontrol from './Dotscontrol';
import iconsort from "./iconsort";
import hrdate from "./hrdate";
import status from "./status";
import statuscamera from "./statuscamera";

export default {
    props: ['title_person'],
    data(){
        return{
            // LengthAwarePaginator JSON from /getcameras (same shape as Videos).
            data: {},
            sort: 'id',
            sorttype: 'desc',
            sort_name: 'up',
            sort_person: 'up',
            model_all: false,
            checklist: [],
            progress: 50,
            analize: false,
            btn_delete_checked: false,
            btn_stop_checked: false,
            btn_analyze_checked: false,
            statuses: [],
            lasthistory: {},
            cur_del_id: '',
            model_find: '',
            model_counitempage: 10,
            page: 1,
            _previewTimer: null,
            previewUrl: {},
            previewReady: {},
        }
    },
    methods: {
        cameraRows() {
            if (Array.isArray(this.data)) {
                return this.data;
            }
            if (this.data && Array.isArray(this.data.data)) {
                return this.data.data;
            }
            return [];
        },
        findname(){
            this.page = 1;
            this.getCameras();
        },
        changePage(page) {
            const n = Math.max(1, parseInt(page, 10) || 1);
            this.page = n;
            this.getCameras();
            window.scrollTo(0, 0);
        },
        onPerPageChange() {
            this.page = 1;
            this.getCameras();
        },
        stopCameras(){
            this.checklist
            .forEach( camId=>this.stopAnalizeCamera(camId) );
            this.clearCheck();
        },
        analizeCameras(){
            
            let requestsPromisesAr = [];
            let curRequestPromise;
            
            this.checklist
            .forEach(
                camId=>{                    
                    let curCamStatusId = this
                    .cameraRows()
                    .filter(
                        cam=>cam.id==camId
                    )[0]
                    .status_id;
                    
                    if(
                        curCamStatusId==3 ||
                        curCamStatusId==4 ||
                        curCamStatusId==5
                    ) 
                        curRequestPromise = this.beginAnalizeCamera(camId);

                    if(!curCamStatusId)
                        curRequestPromise = this.analizeCamera(camId);
                    
                    requestsPromisesAr.push(curRequestPromise);
                }
            );
            
            Promise.all( requestsPromisesAr ).then((values) => {
                // console.log('promise all values: ', values);
                this.clearCheck();
                // console.log('this.model_all from promise all in analize cameras after call this.clearCheck() : ', this.model_all);
            });
            // this.clearCheck();
        },
        changeActivityCommonButtons(newState){
            this.btn_delete_checked = newState;
            this.btn_stop_checked = newState;
            this.btn_analyze_checked = newState;
        },        
        syncSelection(){
            this.checklist = [];
            this.cameraRows().forEach((item) => {
                if (item.checked) {
                    this.checklist.push(item.id);
                }
            });
            const rows = this.cameraRows();
            this.model_all = rows.length > 0
                && rows.every((item) => item.checked);
            this.changeActivityCommonButtons(this.checklist.length > 0);
        },
        changeItem(){
            this.syncSelection();
        },        
        onPreviewError(id) {
            this.$set(this.previewReady, id, false);
            this.$set(this.previewUrl, id, '');
        },
        updateCameraPrev(id, path){
            const hadPreview = !!this.previewReady[id];
            if (!hadPreview) {
                this.$set(this.previewReady, id, false);
            }

            axios.post( '/cameras/updateCameraPrev',
                {
                    'id': id,
                    'path': path
                },
                {
                    timeout: 20000,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((response)=>{
                if (response.data && response.data.error) {
                    if (!hadPreview) {
                        this.$set(this.previewReady, id, false);
                    }
                    return;
                }
                const b64 = (typeof response.data === 'string')
                    ? response.data
                    : (response.data && response.data.frame);
                if (!b64) {
                    if (!hadPreview) {
                        this.$set(this.previewReady, id, false);
                    }
                    return;
                }
                this.$set(
                    this.previewUrl,
                    id,
                    `data:image/jpeg;base64,${String(b64).replace(/\s+/g, '')}`
                );
                this.$set(this.previewReady, id, true);
            }).catch((e) => {
                console.log(e);
                if (!hadPreview) {
                    this.$set(this.previewReady, id, false);
                }
            });
        },
        updateCamerasPrev(cameras){
            console.log( 'uploaded cameras: ', cameras);
            // Stagger RTSP grabs so OpenCV does not stampede the API.
            (cameras || []).forEach((camera, idx) => {
                if (!camera || !camera.id) return;
                setTimeout(() => this.updateCameraPrev(camera.id, camera.path), idx * 400);
            });
        },
        startPreviewPolling(){
            this.stopPreviewPolling();
            // Live streams: refresh thumbnails while the cameras page is open.
            this._previewTimer = setInterval(() => {
                const rows = this.cameraRows();
                rows.forEach((camera, idx) => {
                    if (camera && camera.id && camera.path) {
                        setTimeout(
                            () => this.updateCameraPrev(camera.id, camera.path),
                            idx * 400
                        );
                    }
                });
            }, 8000);
        },
        stopPreviewPolling(){
            if (this._previewTimer) {
                clearInterval(this._previewTimer);
                this._previewTimer = null;
            }
        },
        openCameraStream(camera){
            if (!camera) return;
            bus.$emit('openpopup', {
                open: true,
                type: 'camerastream',
                title_form: camera.name || ('Camera ' + camera.id),
                camera: camera,
                addPopupClass: 'camera-stream-popup',
            });
        },
        getStatuses(){
            axios.get('/getstatuses').then((response) => {
                if(response.data){
                    this.statuses = response.data;
                }
            }).catch(function(){
                console.log('FAILURE STATUSES!!');
            });
        },
        addVideo(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formaddcamera',
                'crud': 'create',
                'title_form': 'Add camera',
            })
        },
        analizeCamera(cameraId){            
            // Optimistic WAIT → STOP button while request is in flight
            const cam = this.cameraRows().find(c => c.id === cameraId);
            if (cam) {
                cam.status_id = 2;
            }
            return axios.post( '/cameras/analize',
                {'camera_id': cameraId},
                {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
            ).then((response)=>{
                console.log('Result add camera to sdk',response);
                if (response.data && response.data.error) {
                    if (cam) {
                        cam.status_id = 5;
                        cam.description = response.data.message || 'Analyze failed';
                    }
                    return;
                }
                this.updateCamera( 
                    cameraId, 
                    {
                        'status': response.data.status || 'wait',
                        'date': Math.round(new Date().getTime() / 1000)
                    } 
                );
            }).catch((e)=>{
                console.log(e);
                if (cam) {
                    cam.status_id = 5;
                    cam.description = 'Analyze request failed';
                }
            });
        },
        stopAnalizeCamera(cameraId){
            const data = {};
            data.status_id = 3;
            // this.getReport( [cameraId] );
            this.updateCamera(cameraId, data);
        },
        beginAnalizeCamera(cameraId){
            // Prefer full analyze/reanalyze path so SDK queue is (re)created.
            // Do NOT force status_id=2 after resolve — that re-shows STOP while
            // SDK already returned wrong/done (classic STOP+WRONG mismatch).
            // analizeCamera already optimistically sets WAIT for the in-flight request.
            return this.analizeCamera(cameraId);
        },
        getReport(arIds, dateBegin = null, dateEnd = null){
            const idsStr = arIds.join(',');
            let data = {
                // "name": `Report_Camera_${id}_${Math.floor(Date.now() / 1000)}`,
                "name": `Report_Cameras_${idsStr}_${Math.floor(Date.now() / 1000)}`,
                "video_id": arIds
            }

            if(dateBegin) data.date_begin = dateBegin;
            if(dateEnd) data.date_end = dateEnd;

            axios.post( `/reports`,
                data,
                {headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}}
            ).then((responce)=>{
                console.log('Result update camera',responce);
            }).catch(function(e){
                console.log(e);
            });
        },        
        updateCamerasPersonsAndHistories(arIds, dateBegin, dateEnd = null){
            const idsStr = arIds.join(',');
            let data = {            
                "create_report": false,
                "date_begin": dateBegin,
                "video_id": arIds
            }
            if(dateEnd) data.date_end = dateEnd;
        },
        updateCamera(id, data){                        
            return axios.put( `/cameras/${id}`,
                data,
                {headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}}
            ).then((response)=>{
                console.log('Result update camera',response);
                this.getCameras();
                this.getStatuses();
            }).catch(function(e){
               console.log(e);
            });
        },
        getSdkCamera(e){
            const cameraId = e.target.dataset.id;
            axios.post( '/cameras/getsdkcam',
                {'camera_id': cameraId},
                {headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}}
            ).then((responce)=>{                
                console.log('Result get camera from sdk',responce);
            }).catch(function(e){
                console.log(e);
            });
        },
        getCameras(upload){
            const url = `/getcameras`;
            let params = {
                page: this.page,
                countitempage: this.model_counitempage,
                sort: this.sort,
                sorttype: this.sorttype,
                find: this.model_find
            };
            
            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            )
                .then((response) => {
                    // handle success
                    console.log(response);
                    // Laravel LengthAwarePaginator JSON: { data: [...rows], total, last_page, ... }
                    const payload = response.data;
                    if (Array.isArray(payload)) {
                        // Legacy bare array — wrap so <pagin> still works.
                        this.data = {
                            data: payload,
                            total: payload.length,
                            per_page: payload.length || this.model_counitempage,
                            current_page: 1,
                            last_page: 1,
                        };
                    } else if (payload && typeof payload === 'object') {
                        this.data = payload;
                        if (payload.current_page) {
                            this.page = Number(payload.current_page) || this.page;
                        }
                    } else {
                        this.data = { data: [], total: 0, per_page: this.model_counitempage, current_page: 1, last_page: 1 };
                    }

                    const rows = this.cameraRows().map((item) => {
                        // Fresh page payload — selection is page-local.
                        item.checked = !!item.checked;
                        if (item.opensetting === undefined) item.opensetting = false;
                        return item;
                    });
                    this.updateCamerasPrev(rows);
                    // Recompute master / checklist from visible rows (clears stuck select-all).
                    this.syncSelection();

                    if(upload){
                        this.autoReports();
                    }
                })
                .catch( (error) => {
                    // handle error
                    console.log(error);
                })
        },
        editCamera(camera){
            console.log(camera);
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formaddcamera',
                'crud': 'update',
                'title_form': 'Update camera',
                'category_id': Number(this.category_id),
                'camera': camera
            });
        },
        sortName(){
            this.sort = 'name';
            if(this.sort_name === 'up'){
                this.sort_name = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_name = 'up';
                this.sorttype = 'asc';
            }
            this.page = 1;
            this.getCameras();
        },
        sortPerson(){
            this.sort = 'status_id';
            if(this.sort_person === 'up'){
                this.sort_person = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_person = 'up';
                this.sorttype = 'asc';
            }
            this.page = 1;
            this.getCameras();
        },
        clearCheck(){
            this.cameraRows().forEach((item) => {
                item.checked = false;
            });
            this.syncSelection();
        },
        checkAll(){
            const checked = !!this.model_all;
            this.cameraRows().forEach((item) => {
                item.checked = checked;
            });
            this.syncSelection();
        },
        deleteCamera(id){            
            this.cur_del_id = id;
            bus.$emit('openalert', {
                open: true,
                alert_title: 'Delete this camera?',
                alert_text: 'This process cannot be undone.',
                action: 'del_camera'
            });
            this.cameraRows().map((item) => {
                if(item.id === id){
                    item.opensetting = false;
                }
            });
        },
        deleteCameras(){
            // console.log('this.checklist: ', this.checklist);
            bus.$emit('openalert', {
                open: true,
                alert_title: 'Delete checked cameras?',
                alert_text: 'This process cannot be undone.',
                action: 'del_cameras'
            });
            
        },
        deleteCameraAction(camera_id){
            axios.delete(
                `/cameras/${camera_id}`,
                {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                }
            ).then((responce)=>{
                console.log('del responce data: ', responce.data);
                if (responce.data && responce.data.error) {
                    console.log('DELETE camera error:', responce.data.message);
                    return;
                }
                // Drop from local list immediately; then refresh from SDK SoT.
                if (this.data && Array.isArray(this.data.data)) {
                    this.data.data = this.data.data.filter((c) => c.id !== camera_id);
                    if (typeof this.data.total === 'number' && this.data.total > 0) {
                        this.data.total -= 1;
                    }
                }
                this.checklist = (this.checklist || []).filter((id) => id !== camera_id);
                this.getCameras();
                this.getStatuses();
                this.model_all = false;
            }).catch((e)=>{
                console.log('FAILURE!!', e);
                const msg =
                    (e && e.response && e.response.data && e.response.data.message) ||
                    (e && e.message) ||
                    'Delete failed';
                console.log(msg);
            });
        },
        openSettings(id){
            this.cameraRows().map((item) => {
                if(item.id === id){
                    item.opensetting = true;
                }
            });
        },
        autoReports(){            
            const ids = this.cameraRows()
                .filter(item => (
                    (item.status_id == 1) || 
                    (item.status_id == 2)
                    // || (item.status_id == 3)
                ) )
                .map(item => item.id);                        
            this.getReport( ids );            
        }
    },
    watch: {

    },
    mounted(){        
        // this.getCameras(true);        
        this.getCameras();
        this.getStatuses();
        this.startPreviewPolling();
    
        // this.autoReports();
        bus.$on('addcategory', (data) => {
            // this.categories.push(data);
            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
            axios.post('/categories', data)
                .then(function (response) {
                    // handle success
                    console.log('handle success', response.data);
                    // if(response.data.name){
                        // Refresh list from SoT rather than pushing into paginator wrongly.
                        this.getCameras();
                        console.log(this.data)
                    // }
                    // this.getCategories();
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
        });
        bus.$on('getListCameras', (data) => {
            if(data){
                this.getCameras();
            }
        });
        bus.$on('camera_sdk_status', (payload) => {
            if (!payload || payload.camera_id == null) return;
            const cam = this.cameraRows().find(c => String(c.id) === String(payload.camera_id));
            if (!cam) return;
            // Prefer explicit SDK status string so WRONG never leaves STOP button up
            const sdkMap = { proc: 1, wait: 2, stop: 3, done: 4, wrong: 5 };
            const sdkKey = String(payload.status || '').toLowerCase();
            if (sdkMap[sdkKey]) {
                cam.status_id = sdkMap[sdkKey];
            } else if (payload.status_id) {
                cam.status_id = payload.status_id;
            } else if (payload.status && this.statuses && this.statuses.length) {
                const st = this.statuses.find(
                    s => String(s.status).toUpperCase() === String(payload.status).toUpperCase()
                );
                if (st) cam.status_id = st.id;
            }
            if (payload.description != null) {
                cam.description = payload.description;
            }
        });
        bus.$on('historiesloaded', (data) => {
            
            
            // console.log('historiesloaded fire! ) ');
            
            // console.log('data.lasthistory: ', data.lasthistory );
            
            if(data.lasthistory && data.lasthistory != 'begin'){
                this.lasthistory = data.lasthistory;                
                let lh = data.lasthistory,
                    lDstr = lh.recognized_at,
                    gmtObj = hVue.getGmtObjFromStr(lDstr),
                    utcLdate = hVue.getUtcFromGmtObj(gmtObj),
                    utcNowDate = new Date().getTime(),
                    minPeriod = 1*1000*60,
                    utcLdateSec = utcLdate/1000,
                    idsAr = this.idsCamsToAutoReport;
                    
                    // console.log('idsAr', idsAr);
                    // console.log('utcLdateSec', idsAr);

                if( (utcNowDate - utcLdate) > minPeriod ){
                    this.updateCamerasPersonsAndHistories(idsAr, utcLdateSec);
                }
            }
            
            if(data.lasthistory && data.lasthistory == 'begin'){
                let idsAr = this.idsCamsToAutoReport;
                this.updateCamerasPersonsAndHistories(idsAr, 0);
            }

        });
        
        bus.$on('resultalert', (data) => {            
            if(data.action == 'del_camera' ){                
                if(data.confirm) this.deleteCameraAction(this.cur_del_id);
            }
            if(data.action == 'del_cameras' ){
                if(data.confirm){
                    // this.checklist.forEach(camId=>console.log(camId));
                    // this.deleteCameraAction(this.cur_del_id);
                    this.checklist
                    .forEach(
                        camId=>this.deleteCameraAction(camId)
                    );
                }
            }

        });
    },
    beforeDestroy(){
        this.stopPreviewPolling();
    },
    computed: {
        camerasItem(){
            return this.cameraRows();
        },
        idsCamsToAutoReport(){
            return this.cameraRows().map((item) => item.id);
        }
    },
    components: {
        Dotscontrol,
        iconsort,
        hrdate,
        status,
        statuscamera,
        Pagin,
    }
}
</script>

<style lang="scss" scoped>
.not_found{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #041541;
    color: #fff;
    width: 130px;
    min-height: 80px;
}
.previewCol{
    cursor: pointer;
}
.camera-preview-wrap{
    width: 130px;
    min-height: 72px;
}
.camera-preview-placeholder{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    min-height: 72px;
    background: #041541;
    border-radius: 4px;
    cursor: pointer;
}
.camera-preview-spinner{
    width: 28px;
    height: 28px;
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: camera-preview-spin 0.85s linear infinite;
}
@keyframes camera-preview-spin {
    to {
        transform: rotate(360deg);
    }
}
.camera-preview-thumb{
    cursor: pointer;
    border-radius: 4px;
    min-height: 72px;
    background: #041541;
    object-fit: cover;
    transition: outline-color 0.15s ease, transform 0.15s ease;
    outline: 1px solid transparent;
}
.camera-preview-wrap:hover .camera-preview-thumb,
.camera-preview-wrap:hover .camera-preview-placeholder{
    outline: 1px solid #3b82f6;
}
.camera-preview-wrap:hover .camera-preview-thumb{
    transform: scale(1.02);
}
</style>
